import Raven from 'raven-js';
import { MagpieConnection } from 'magpie-lib/connection';
import { useEffect, useMemo, useState } from 'react';
export const useMagpieTopic = topicDef => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const topic = useMemo(() => {
    return MagpieConnection.get().useTopic(topicDef, {
      subscribe: true
    });
  }, [topicDef]);
  useEffect(() => {
    topic.onSubscriptionChange(setIsSubscribed);
    return () => {
      topic.removeSubscriptionChangeListener(setIsSubscribed);
    };
  }, [topic]);
  const subscribe = () => {
    topic.subscribe().catch(error => {
      Raven.captureException(error, {
        extra: {
          message: 'Failed to subscribe to topic',
          component: 'useMagpieTopic',
          context: 'Subscribe failed in the useMagpieTopic hook in copilot-plugins hook'
        }
      });
    });
  };
  const unsubscribe = () => {
    topic.unsubscribe().catch(error => {
      Raven.captureException(error, {
        extra: {
          message: 'Failed to unsubscribe from topic',
          component: 'useMagpieTopic',
          context: 'Unsubscribe failed in the useMagpieTopic hook in copilot-plugins hook'
        }
      });
    });
  };
  return {
    topic,
    subscribe,
    unsubscribe,
    isSubscribed
  };
};